export const MARKETS_DE = {
    match_odds_ft: "Spielergebnis (Spielende)",
    match_odds_ht: "Spielergebnis (Halbzeit)",
    goals_ft: "Über/Unter {{line}} Tore (Spielende)",
    goals_ht: "Über/Unter {{line}} Tore (Halbzeit)",
    player_scores: "{{player}} trifft (Spielende)",
    corners_ft: "Ecken über/unter {{line}} (Spielende)",
    cards_ft: "Karten über/unter {{line}} (Spielende)",
    draw: "Unentschieden",
    over: "Über {{line}}",
    under: "Unter {{line}}",
    yes: "Ja",
    no: "Nein",
}
